import { render, staticRenderFns } from "./person.vue?vue&type=template&id=6605a72a&scoped=true&"
import script from "./person.vue?vue&type=script&lang=ts&"
export * from "./person.vue?vue&type=script&lang=ts&"
import style0 from "./person.vue?vue&type=style&index=0&id=6605a72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6605a72a",
  null
  
)

export default component.exports